<template>
  <nav class="bottom-nav">
    <router-link to="/">
      <svg xmlns="http://www.w3.org/2000/svg" width="42.8" height="38.19" viewBox="0 0 42.8 38.19" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="2">
        <path d="M40.26,19.36l-18-18a1.2,1.2,0,0,0-1.7,0l-18,18a1.19,1.19,0,0,0,0,1.7,1.17,1.17,0,0,0,.85.35H6.63a1.21,1.21,0,0,1,1.21,1.21V36A1.2,1.2,0,0,0,9,37.19H34A1.21,1.21,0,0,0,35.18,36h0V22.62a1.2,1.2,0,0,1,1.2-1.2h3a1.21,1.21,0,0,0,.85-2.06Z"/>
        <line x1="3.1" y1="21.36" x2="17.9" y2="21.36" />
        <line x1="22.43" y1="21.36" x2="24.48" y2="21.36" />
      </svg>
      <p>Accueil</p>
    </router-link>
    <router-link to="/map">
      <svg xmlns="http://www.w3.org/2000/svg" width="42.8" height="38.19" viewBox="0 0 42.8 38.19" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="none">
        <path d="M16.31,18.64l-1.2,14.74Q8.69,35.15,1.72,36.91a.57.57,0,0,1-.7-.42.45.45,0,0,1,0-.28L5.66,17.3A.6.6,0,0,1,6,16.89q4.38-1.41,8.4-2.84" />
        <path d="M27.64,22.1l.8,10.38.32,4a.58.58,0,0,0,.63.53l.1,0q6.21-1.71,11.9-3.42a.56.56,0,0,0,.39-.69l-1-4" />
        <path d="M28.43,32.48c.11,1.29.22,2.57.32,3.85a.58.58,0,0,1-.54.62.37.37,0,0,1-.18,0q-6.74-1.77-12.92-3.55.57-7,1.15-14" />
        <path d="M39.65,24.21,37.12,13.89a.58.58,0,0,0-.7-.43l-.08,0-9.48,4,.84-2" />
        <path d="M24.94,21.72C23.8,24.17,23.19,25.4,22.39,27a1.17,1.17,0,0,1-1.58.51A1.14,1.14,0,0,1,20.3,27c-1-2-2.58-5.13-4-8.31-.7-1.57-1.35-3.15-1.88-4.58a16.39,16.39,0,0,1-1.2-4.77,8.1,8.1,0,0,1,16.2,0A20.76,20.76,0,0,1,27.7,15.5" />
        <circle cx="21.35" cy="9.29" r="3.77" />
      </svg>
      <p>Carte</p>
    </router-link>
    <router-link to="/settings">
      <svg xmlns="http://www.w3.org/2000/svg" width="42.8" height="38.19" viewBox="0 0 42.8 38.19" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M21.18,22.69a7.65,7.65,0,0,1-4.4-1.41,11.37,11.37,0,0,1-4.49-9.39c0-6,4-10.8,8.89-10.8s8.88,4.84,8.88,10.8a11.4,11.4,0,0,1-4.34,9.29l-.14.11A4.38,4.38,0,0,0,28.17,25l4.91,2.18a4.39,4.39,0,0,1,2.61,4v3.34A2.59,2.59,0,0,1,33.1,37.1H9.7a2.59,2.59,0,0,1-2.59-2.59V31.12a4.39,4.39,0,0,1,2.54-4L14.25,25a4.39,4.39,0,0,0,2.51-3.51" fill="none" />
      </svg>
      <p>Paramètres</p>
    </router-link>
  </nav>
</template>

<script>
export default {
  methods: {
    logout () {
      this.$store.dispatch('login', false)
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-nav {
  flex-shrink: 0;
  backdrop-filter: brightness(1.3) blur(10px);
  padding: 16px;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  display: flex;
  justify-content: space-around;
  z-index: 100;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.06);
  a {
    font-size: 0;
    &.router-link-exact-active {
      svg {
        stroke: #F07A87;
      }
    }
  }
}
</style>
